import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  Organization,
  OrganizationChatScope,
} from "src/app/shared/interfaces/organization";
import { Guid } from "src/app/shared/types/guid";

export const organizationsPrefix = "[Organizations List]";

const organizationsListActions = {
  request: `${organizationsPrefix} Load`,
  requestSuccess: `${organizationsPrefix} Load success`,
  requestFail: `${organizationsPrefix} Load fail`,
};

export const organizationsListLoad = createAction(
  organizationsListActions.request,
);

export const organizationsListLoadSuccess = createAction(
  organizationsListActions.requestSuccess,
  props<{ organizations: Organization[] }>(),
);

export const organizationsListLoadFail = createAction(
  organizationsListActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);

export const organizationChatSettingsLoad = createAction(
  `${organizationsPrefix} Load chat settings`,
  props<{ organizationId: Guid }>(),
);

export const organizationChatSettingsLoadSuccess = createAction(
  `${organizationsPrefix} Load chat settings success`,
  props<{ organizationId: Guid; chatScope: OrganizationChatScope }>(),
);

export const organizationChatSettingsLoadFail = createAction(
  `${organizationsPrefix} Load chat settings fail`,
  props<{ organizationId: Guid; error: HttpErrorResponse }>(),
);

export const organizationChatSettingsUpdate = createAction(
  `${organizationsPrefix} Update chat settings`,
  props<{
    organizationId: Guid;
    chatScope: OrganizationChatScope;
    previousChatScope: OrganizationChatScope;
  }>(),
);

export const organizationChatSettingsUpdateSuccess = createAction(
  `${organizationsPrefix} Update chat settings success`,
  props<{ organizationId: Guid; chatScope: OrganizationChatScope }>(),
);

export const organizationChatSettingsUpdateFail = createAction(
  `${organizationsPrefix} Update chat settings fail`,
  props<{
    organizationId: Guid;
    previousChatScope: OrganizationChatScope;
    error: HttpErrorResponse;
  }>(),
);
